"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
require("core-js/modules/es.symbol.js");
require("core-js/modules/es.symbol.description.js");
require("core-js/modules/es.symbol.iterator.js");
require("core-js/modules/es.array.iterator.js");
require("core-js/modules/es.object.define-property.js");
require("core-js/modules/es.object.get-own-property-descriptor.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/es.string.iterator.js");
require("core-js/modules/es.weak-map.js");
require("core-js/modules/web.dom-collections.iterator.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require("core-js/modules/es.array.concat.js");
require("core-js/modules/es.number.to-fixed.js");
require("core-js/modules/es.parse-float.js");
var _react = _interopRequireDefault(require("react"));
var _constellation = require("@zillow/constellation");
var S = _interopRequireWildcard(require("./styles"));
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
// Constellation

// Misc / Utils

var ZRM_URL = 'zillow.com/rental-manager';
function displayCurrency(number) {
  return '$' + parseFloat(number.toFixed(2)).toLocaleString();
}
var Results = function Results(props) {
  var itc = props.itc,
    proratedRent = props.proratedRent,
    reset = props.reset,
    t = props.t;
  var zrmUrlWithTracking = "//".concat(ZRM_URL, "?itc=").concat(itc, "&t=").concat(t);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(S.CenterSpacer, {
    marginTop: "lg",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_constellation.Spacer, {
      marginBottom: "xl",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_constellation.Text, {
        as: "p",
        fontType: _constellation.FONT_TYPES.h6,
        marginBottom: "xs",
        children: ["Prorated rent for the month of ", proratedRent.month]
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_constellation.Text, {
        as: "p",
        fontType: _constellation.FONT_TYPES.h2,
        marginBottom: "xs",
        children: displayCurrency(proratedRent.days * proratedRent.dailyRent)
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_constellation.Text, {
        as: "p",
        fontType: _constellation.FONT_TYPES.body,
        marginBottom: "xs",
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("strong", {
          children: proratedRent.days
        }), " days * ", /*#__PURE__*/(0, _jsxRuntime.jsx)("strong", {
          children: displayCurrency(proratedRent.dailyRent)
        }), " per day"]
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_constellation.Spacer, {
      marginBottom: "lg",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(S.FixedWidthButton, {
        buttonType: "primary",
        fluid: true,
        onClick: reset,
        width: 232,
        children: "Reset"
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(S.SizeTwentyText, {
      as: "p",
      marginBottom: "xs",
      children: "Want to streamline managing your properties?"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(S.SizeTwentyTextButton, {
      as: "a",
      href: zrmUrlWithTracking,
      children: "Explore Zillow Rental Manager"
    })]
  });
};
var _default = exports["default"] = Results;